import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../../shared/store/hooks';
import { logoutThunk } from '../../../shared/store/authSlice';
import './userAccountLayout.css';

interface NavItem { to: string; label: string; icon: string }

const NAV: NavItem[] = [
    { to: '/user/dashboard', label: 'Dashboard', icon: '⊞' },
    { to: '/user/orders',    label: 'My Orders',  icon: '📦' },
    { to: '/user/wishlist',  label: 'Wishlist',   icon: '♡' },
    { to: '/user/profile',   label: 'Profile',    icon: '👤' },
    { to: '/user/address',   label: 'Addresses',  icon: '📍' },
];

interface Props { children: React.ReactNode }

export const UserAccountLayout: React.FC<Props> = ({ children }) => {
    const { user } = useAppSelector(s => s.auth);
    const dispatch = useAppDispatch();
    const { pathname } = useLocation();

    const initials = user?.name
        ? user.name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()
        : '?';

    return (
        <div className="ua-layout">
            <aside className="ua-sidebar">
                <div className="ua-user-block">
                    <div className="ua-avatar">
                        {user?.avatar
                            ? <img src={user.avatar} alt={user.name} />
                            : initials
                        }
                    </div>
                    <div className="ua-user-info">
                        <span className="ua-user-name">{user?.name ?? 'User'}</span>
                        <span className="ua-user-email">{user?.email}</span>
                        <span className="ua-verified-badge">✓ Verified</span>
                    </div>
                </div>

                <nav className="ua-nav">
                    {NAV.map(({ to, label, icon }) => (
                        <Link
                            key={to}
                            to={to}
                            className={`ua-link${pathname.startsWith(to) ? ' active' : ''}`}
                        >
                            <span className="ua-link-icon">{icon}</span>
                            {label}
                        </Link>
                    ))}
                </nav>

                <button className="ua-signout" onClick={() => dispatch(logoutThunk())}>
                    Sign Out
                </button>
            </aside>

            <main className="ua-main">
                {children}
            </main>
        </div>
    );
};
